import { Table, TableName } from '@openx/components-table/Table';
import type { AllTableCriteria } from '@openx/types/tableCriteria';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsDecidedSensitiveCategoriesColumns } from '../constants';
import type { DealAdCategoryProposal } from '../model';
import type { DealsSensitiveCategoriesListFilters, ShareDealsSensitiveCategoriesListProps } from '../types';

const DealsSensitiveCategoriesSimpleTable = Table<DealAdCategoryProposal>;

export function DealDecidedSensitiveCategoriesList({
  activeTab,
  items,
  criteria,
  onCriteriaChange,
}: ShareDealsSensitiveCategoriesListProps) {
  const { t } = useTranslation();

  const listCriteria: AllTableCriteria<DealsSensitiveCategoriesListFilters> = useMemo(() => {
    if (criteria.sort && criteria.sort?.column === 'proposedDate') {
      return {
        ...criteria,
        sort: {
          ...criteria.sort,
          column: 'decisionDate',
        },
      };
    }

    return criteria;
  }, [criteria]);

  const columns = useMemo(() => getDealsDecidedSensitiveCategoriesColumns(activeTab, t), [activeTab, t]);

  return (
    <DealsSensitiveCategoriesSimpleTable
      loading={false}
      name={TableName.DEALS_SENSITIVE_CATEGORIES_DECIDED}
      data={items}
      columns={columns}
      criteria={listCriteria}
      onCriteriaChange={onCriteriaChange}
    />
  );
}
